import React from "react";
import VariantGate from './_variant_gate';
import MaintenancePageV2 from '../components/maintenance_page_v2/maintenance_page_v2';
import MaintenancePageV3 from '../components/maintenance_page_v3/maintenance_page_v3';
import NavBar from "../components/common/nav_bar";
import MaintenanceBanner from "../components/common/maintenance_banner";
import MaintenanceCard from "../components/my_page/maintenance_card";
import ScrollToTopButton from "../components/common/scroll_to_top_button";
import { getNavCollapsed, setNavCollapsed } from "../utils/navState";

class MaintenancePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: getNavCollapsed(),
        };
    }

    onCollapse = (collapsed) => {
        setNavCollapsed(collapsed);
        this.setState({ collapsed });
    };

    render() {
        const { collapsed } = this.state;
        return (
            <div className="min-h-screen w-full bg-surface text-content sm:overflow-x-auto">
                <NavBar collapsed={collapsed} onCollapse={this.onCollapse} />
                <main
                    className={`min-w-0 w-full pt-12 pb-16 sm:pt-0 sm:pb-0 transition-[padding-left] duration-200 ${
                        collapsed ? "sm:pl-[56px]" : "sm:pl-[220px]"
                    }`}
                    style={{ marginTop: "var(--maintenance-banner-h, 0px)" }}
                >
                    <MaintenanceBanner />
                    <div className="mx-3 my-3 min-w-0 sm:mx-6 sm:my-5">
                        <div className="mb-4">
                            <div className="text-sm text-content-secondary">시스템 운영 / 거래소 점검 일정</div>
                            <h1 className="mt-1 text-xl font-semibold text-content">점검 일정 관리</h1>
                            <p className="mt-1 text-xs text-content-muted">
                                등록한 시간 동안 해당 거래소의 잔고 캐싱 / 스냅샷 / 청산 알림 등 모든 모니터링이 자동 일시 중단됩니다.
                            </p>
                        </div>
                        <MaintenanceCard />
                    </div>
                </main>
                <ScrollToTopButton />
            </div>
        );
    }
}

// DAS-70 Wave-A: variant 슬롯 3-단 확장 (v1 / v2 슬롯 / v3 정보 구조 재설계)
const MaintenancePageV1 = MaintenancePage;
export { MaintenancePageV1 };
const MaintenancePageWithVariant = (props) => (
    <VariantGate v1={MaintenancePageV1} v2={MaintenancePageV2} v3={MaintenancePageV3} fallbackToV1={true} {...props} />
);
export default MaintenancePageWithVariant;
